(function() {

    var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";
    var isLogin    = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

    var eventAuth = {
        init: function() {
            var self = this;

            vcui.require([
                'ui/imageFileInput', 'ui/validation'
            ], function() {
                self.setting();
                self.bindEvents();
                self.setAnniversaryDate();
            });
        },

        setting: function() {
            var self = this;

            self.$popupOpenButton = $('#authCertButton, [data-btn-link=weddingAuth]');
            self.$popup = $('#popup1');
            self.$authSuccessPopup = $('#popup2');
            self.$authSubmitButton = self.$popup.find('[name=authSubmitButton]');
            self.$popupOpener = null;
            self.initImageFileInput();

            var register = {
                anniversary: {
                    required: true,
                },
                imageFile1: {
                    required: true,
                } ,
                planEventId: {
                    required: true,
                } ,
                certType: {
                    required: true,
                }
            }

            self.validation = new vcui.ui.CsValidation('#eventauthfrm', {register:register});
        },

        initImageFileInput: function() {
            var self = this;
            var options = {
                totalSize: 10 * 1024 * 1024,
                individualFlag: true,
                individual: {
                    size: 10 * 1024 * 1024
                },
                format: 'jpg|jpeg|png|JPG|JPEG|PNG',
                message: {
                    format: '10MB 이하의 JPEG, PNG 파일만 첨부 가능합니다.',
                    size: '첨부파일 크기는 10M 이하로 등록해 주세요.'
                },
                useMaskEditor: true,
                delCompleted: function() {
                    self.updateAuthButtonState();
                },
                maskCompleted: function() {
                    self.updateAuthButtonState();
                }
            };

            self.$popup.find('.ui_imageinput').each(function() {
                var $el = $(this);
                var instance = $el.vcImageFileInput('instance', false);
                if (instance) {
                    $.extend(instance.options, options);
                } else {
                    $el.vcImageFileInput(options);
                }
            });
        },

        bindEvents: function() {
            var self = this;

            // 웨딩인증하기 팝업
            self.$popupOpenButton.on('click', function(e) {
                self.$popupOpener = $(this);
                if (isLogin == "N") {
                    var obj = {title:'로그인이 필요합니다.<br>이동하시겠습니까?', cancelBtnName:'아니오', okBtnName:'네', ok: function () { self.goLogin(); }};
                    lgkorUI.confirm(null, obj, $(this)); //BTOCSITE-77414 > WA 전문가점검
                } else {
                    self.loginPlanEventAuthStatus();
                }
            });

            $("input:radio[name='chk11']").on('change', function(e) {
                if($(this).val() == "N" ){
                    $('#popup-privacy-confirm-button').addClass('disabled');
                }else{
                    $('#popup-privacy-confirm-button').removeClass('disabled');
                }
            });

            $('#popup-privacy-confirm-button').on('click', function(e) {
                if( $('#chk11-Y').is(':checked') ){
                    $('#chk-pri1').prop("checked", true);
                    $('#popup-privacy-close-button').click();
                    self.updateAuthButtonState();
                }else{
                    lgkorUI.alert("", {
                        title: '개인정보 수집 이용에 동의해 주세요.'
                    }, $('#chk11-Y'));
                }
            });

            $('#popup-privacy-cancel-button,#popup-privacy-close-button').on('click', function(e) {
                if( $('#chk11-Y').is(':checked') ){
                    $('#chk-pri1').prop("checked", true);
                }else{
                    $('#chk-pri1').prop("checked", false);
                }
                self.updateAuthButtonState();
            });

            $('#eventauthfrm').on('change input', function() {
                self.updateAuthButtonState();
            });

            $('#anniversary').on('calendarinsertdate', function() {
                self.updateAuthButtonState();
            });

            // 인증구분(결혼예정/결혼기념) 변경 시 날짜 초기화 + 캘린더 min/max 재설정
            $("input:radio[id^='anniversaryType']").on('change', function() {
                $('#anniversary').val('');
                self.setAnniversaryDate();
                self.updateAuthButtonState();
            });

            // 웨딩쿠폰 받기
            $('#wedcoupon').on('click', function(e) {
                e.preventDefault();
                var url = $(this).data('open-url');
                var loginflag = $('#exhibitionDiv').data("loginflag");
                var authStatus = $('#exhibitionDiv').data("authstatus");

                if( loginflag == 'N'){
                    var obj = {title:'로그인이 필요합니다.<br>이동하시겠습니까?', cancelBtnName:'아니오', okBtnName:'네', ok: function (){ self.goLogin(); }};
                    lgkorUI.confirm(null, obj);
                    return;
                }else{
                    if( authStatus == '1' ){
                        window.open(url, '_blank');
                    }else if( authStatus == '0' ){
                        lgkorUI.alert("", {title: '담당자가 인증신청내용 확인중입니다.<br>약 1~2일 정도의 기간이 소요됩니다.', ok: function(){ }});
                        return;
                    }else{
                        lgkorUI.alert("", {title: '웨딩인증이 완료된 회원만 확인가능합니다.', ok: function(){ }});
                        return;
                    }
                }
            });

            // 보유 제품 등록 여부 처리
            $('#calcwed').on('click', function(e) {
                e.preventDefault();
                var url = $(this).data('open-url');
                var loginflag = isLogin;

                if( loginflag == 'N'){
                    var obj = {title:'로그인이 필요합니다.<br>이동하시겠습니까', cancelBtnName:'아니오', okBtnName:'네', ok: function (){ self.goLogin(); }};
                    lgkorUI.confirm(null, obj);
                    return;
                }else{
                    window.open(url, '_blank');
                }
            });

            $('[data-control="modal"]').each(function() {
                var target = $(this).data('href') || $(this).attr('href');
                $(target).on('modalshow', function(e, modal) {
                    $(target).removeAttr('style');
                });
            });

            // 웨딩인증 저장
            self.$authSubmitButton.on('click', function(e) {
                var check = self.validation.getCheckValidate();
                var agree = $('#chk-pri1').prop('checked');
                if (check && check.isSuccess && agree) {
                    var obj = {
                        title:'저장하시겠습니까?',
                        cancelBtnName: '아니오',
                        okBtnName: '예',
                        ok: function() {
                            eventAuth.authSave();
                        }
                    };
                    lgkorUI.confirm('', obj, $(this));
                }
            });

            // 웨딩인증 success 후 확인 버튼
            self.$authSuccessPopup.find('[data-role=ok]').on('click', function(e) {
                // 이전 모달이 모두 닫힌 뒤 상담 팝업 오픈 (모달 z-index 꼬임 방지)
                $(document).one('modallastclose', function() {
                    embedConsultReserve.open(self.$popupOpener);
                });
                self.$popup.vcModal('hide');
            });
            // 웨딩인증 success 후 취소 버튼
            self.$authSuccessPopup.find('[data-role=cancel]').on('click', function(e) {
                self.$popup.vcModal('hide');
            });
        },

        // 웨딩인증 초기화
        initAuth: function() {
            var self = this;
            $('[name=anniversaryType]:first').prop('checked', true);
            $('#anniversary').val('');
            $('#chk-pri1').prop('checked', false);
            $('input[name=chk11]').prop('checked', false);
            $('#popup-privacy-confirm-button').addClass('disabled');
            self.$popup.find('.ui_imageinput').vcImageFileInput('removeAll');
            self.initImageFileInput();
            self.setAnniversaryDate();
            self.collapseAccordions();
            self.updateAuthButtonState();
        },

        // 버튼 활성/비활성 (pink / dark-gray)
        updateAuthButtonState: function() {
            var self = this;
            var check = self.validation.getCheckValidate();
            var agree = $('#chk-pri1').prop('checked');

            if (check && check.isSuccess && agree) {
                self.$authSubmitButton.removeClass('dark-gray').addClass('pink');
            } else {
                self.$authSubmitButton.removeClass('pink').addClass('dark-gray');
            }
        },

        // 펼침 영역 접기 (증빙서류, 반려대상)
        collapseAccordions: function() {
            var self = this;
            self.$popup.find('.accordion-border-wrap .lists.on').each(function() {
                $(this).find('.ui_accord_toggle').trigger('click');
            });
        },

        // 인증 상태 조회 후 팝업 오픈
        loginPlanEventAuthStatus: function() {
            var self = this;
            var params = {certType: "wd", location: "weding"};
            var certUrl = $('#exhibitionDiv').data("cert-url");

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(certUrl, params, function(result) {
                lgkorUI.hideLoading();
                var data = (result.data && result.data.length > 0) ? result.data[0] : null;
                if (result.status == 'fail') {
                    if (data && data.loginYn == 'N') {
                        var obj = {
                            title: '로그인이 필요합니다.<br>이동하시겠습니까?',
                            cancelBtnName: '아니오',
                            okBtnName: '네',
                            ok: function () { self.goLogin(); }
                        };
                        lgkorUI.confirm(null, obj, self.$popupOpener);
                    } else {
                        lgkorUI.alert("", {
                            title: result.message ? result.message : '인증 정보 조회가 실패했습니다.<br>다시 시도해 주세요.'
                        }, self.$popupOpener);
                    }
                    return;
                }
                if (result.status == 'success') {
                	if (!data || !data.usrInfo) {
                        lgkorUI.alert("", {
                            title: result.message ? result.message : '인증 정보 조회가 실패했습니다.<br>다시 시도해 주세요.'
                        }, self.$popupOpener);
                        return;
                    }
                    self.initAuth();
                    $("#buyerName").val(data.usrInfo.name);       // 성명
                    $("#buyerPhone").val(data.usrInfo.mobileNo);  // 전화번호
                    $("#certType").val("wd");
                    self.$popup.vcModal({ opener: self.$popupOpener }).vcModal('open');
                }
            }, true);
        },

        // 웨딩인증 저장
        authSave: function() {
            var self = this;
            var ajaxUrl = $('#eventauthfrm').data('ajax');
            var param = self.validation.getAllValues();
            var formData = new FormData();
            for (var key in param) {
                formData.append(key, param[key]);
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxFileData(ajaxUrl, formData, function(result) {

                lgkorUI.hideLoading();
                if (result.status == 'success') {
                    self.$authSuccessPopup.vcModal({opener:self.$popupOpener}).vcModal('open');
                } else {
                    lgkorUI.alert("", {title: result.message ? result.message : '웨딩 인증 신청에 실패했습니다.<br>다시 시도해 주세요.', ok: function(){
                    }}, self.$authSubmitButton);
                }
            }, 'POST');
        },

        goLogin: function() {
            location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
        },

        // 인증구분에 따른 캘린더 min/max 설정
        setAnniversaryDate: function() {
            var nowDate = new Date();
            var nextDate = new Date();
            var postDate = new Date();
            var frstDay = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);

            if( $('#anniversaryType1').is(':checked') ){ // 결혼예정일
                nextDate.setMonth(frstDay.getMonth() + 6);
                $('#anniversaryCalButton').vcCalendar("setMinDate", nowDate);
                $('#anniversaryCalButton').vcCalendar("setMaxDate", nextDate);
            } else if( $('#anniversaryType2').is(':checked') ){ // 결혼기념일
                postDate.setMonth(frstDay.getMonth() - 6);
                $('#anniversaryCalButton').vcCalendar("setMinDate", postDate);
                $('#anniversaryCalButton').vcCalendar("setMaxDate", nowDate);
            }
        },

    }

    window.eventAuth = eventAuth;

    $(document).ready(function() {
        // 웨딩인증 마크업이 있을 때만 초기화
        if ($('#eventauthfrm').length && $('#authCertButton, [data-btn-link=weddingAuth]').length) {
            eventAuth.init();
        }
    });

})();
